export default __webpack_public_path__ + "static/media/tascImg.046c095d.png";